export {
  ENTITY_STATUS_ACTIVE_INACTIVE_OPTIONS as CUSTOMER_STATUS_FILTER_OPTIONS,
  formatEntityStatusLabel as formatCustomerStatusLabel,
} from '#/modules/commonComponents/table/entityStatus';

export function canActivateCustomer(status) {
  return status === 'INACTIVE';
}

export function canDeactivateCustomer(status) {
  return status === 'ACTIVE';
}
